export const textTags = [
    "{X}",
    "{0}",
    "{dullicon}",
    "{crystalicon}",
    "{fireicon}",
    "{iceicon}",
    "{windicon}",
    "{earthicon}",
    "{lightningicon}",
    "{watericon}",
    "{anycosticon}",
    "{specialicon}",
    "{multiicon}",
    "{exburstlabel}",
    "{limitbreakicon}"
] as const;

export type TextTag = typeof textTags[number];

export const TEXT_TAGS = {
    dullIcon: "{dullicon}" as TextTag,
    crystalIcon: "{crystalicon}" as TextTag,
    fireIcon: "{fireicon}" as TextTag,
    iceIcon: "{iceicon}" as TextTag,
    windIcon: "{windicon}" as TextTag,
    earthIcon: "{earthicon}" as TextTag,
    lightningIcon: "{lightningicon}" as TextTag,
    waterIcon: "{watericon}" as TextTag,
    anyCostIcon: "{X}" as TextTag,
    specialIcon: "{specialicon}" as TextTag,
    multiIcon: "{multiicon}" as TextTag,
    exBurstLabel: "{exburstlabel}" as TextTag,
    limitBreakIcon: "{limitbreakicon}" as TextTag,
    zeroCostIcon: "{0}" as TextTag
}

export const iconMapping: Record<string, string> = {
    "lightningicon": "lightning",
    "earthicon": "earth",
    "fireicon": "fire",
    "windicon": "wind",
    "watericon": "watericon",
    "iceicon": "ice",
    "dullicon": "dull",
    "specialicon": "special",
    "multiicon": "multicard"
}

export type TextTagInfo = {
    tag: TextTag,
    name: string,
    type: "icon" | null,
    class: string | null
}

export const textTagInfo: TextTagInfo[] = [
    { name: "Fire", class: "fire", tag: "{fireicon}", type: "icon" },
    { name: "Ice", class: "ice", tag: "{iceicon}", type: "icon" },
    { name: "Wind", class: "wind", tag: "{windicon}", type: "icon" },
    { name: "Earth", class: "earth", tag: "{earthicon}", type: "icon" },
    { name: "Lightning", class: "lightning", tag: "{lightningicon}", type: "icon" },
    { name: "Water", class: "water", tag: "{watericon}", type: "icon" },
    { name: "Zero Cost", class: "", tag: "{0}", type: null },
    { name: "Any Cost", class: "", tag: "{anycosticon}", type: null },
    { name: "Crystal", class: "", tag: "{crystalicon}", type: null },
    { name: "Dull", class: "dull", tag: "{dullicon}", type: "icon" },
    { name: "Special", class: "special", tag: "{specialicon}", type: "icon" },
    { name: "Multi", class: "multicard", tag: "{multiicon}", type: "icon" },
]